<div class="full-height full-width">
    <div class="row full-width centerWithFlex zero-margin" style="height: 20%;">
        <div class="full-width vert-center justify-end zero-padding" style="height: 10%;">
            <mat-icon matTooltip="Close popup" color="red" (click)="closePop($event, false)">close</mat-icon>
        </div>
        <div class="centerWithFlex topPaddingForComp" style="width: 60%; height: 60%;">
            <img class="full-height full-width" src="../assets/vaadude_old.png" />
        </div>
        <!-- <div style="width: 10%; height: 100%;"></div> -->
    </div>
   

    <!-- Forgot Password -->
    <div *ngIf="!isChangePwd" class="centerWithFlex full-width topPaddingForComp" style="height: 20%;">
        <div class="full-height" style="width: 90%; display: grid;">
            <div class="full-width vert-center zero-padding">
                <span style="width: 50%; font-size: 14px;">Email</span>
                <input type="text" id="fgt-emil" name="fgt-emil" [tabIndex]="1" class="form-control" (keyup)="handleEmil($event)" [(ngModel)]="email">
            </div>
            <div class="full-width fieldTopBottomPadding display-flex">
                <span *ngIf="!emailReq" class="hidden-field" style="width: 33%; font-size: 14px; margin-top: -2%;">a</span>
                <span *ngIf="emailReq" class="login-error-div">Email is required</span>
            </div>
        </div>
    </div>
    <div *ngIf="!isChangePwd" class="centerWithFlex full-width" style="height: 20%;">
        <div class="full-height" style="width: 90%; display: grid;">
            <div class="full-width vert-center zero-padding">
                <span style="width: 50%; font-size: 14px;">Date of Birth</span>
                <input type="date" id="fgt-dob" name="fgt-dob" [tabIndex]="1" class="form-control" [(ngModel)]="dob" (ngModelChange)="handleDob($event)">
            </div>
            <div class="full-width fieldTopBottomPadding display-flex">
                <span *ngIf="!dobReq" class="hidden-field" style="width: 33%; font-size: 14px; margin-top: -2%;">a</span>
                <span *ngIf="dobReq" class="login-error-div">Date of birth is required</span>
            </div>
        </div>
    </div>
    <div *ngIf="!isChangePwd" class="centerWithFlex full-width topPaddingForComp" style="height: 20%;">
        <button style="font-size: 14px; min-width: 25%; margin-right: 5%;background-color: green; color: white;" class="btn btn-outline-secondary rounded-pill button-align" (click)="continue($event, true)">Continue</button>
        <button style="font-size: 14px; min-width: 25%;" class="btn btn-outline-secondary rounded-pill button-align" (click)="closePop($event, false)">Cancel</button>
    </div>

    <!-- Change Password -->
    <div *ngIf="isChangePwd" class="centerWithFlex full-width topPaddingForComp" style="height: 20%;">
        <div class="full-height" style="width: 90%; display: grid;">
            <div class="full-width vert-center zero-padding">
                <span style="width: 50%; font-size: 14px;">New Password</span>
                <input type="password" id="new-pass" name="new-pass" [tabIndex]="1" class="form-control" (keyup)="handleNewPwd($event)" [(ngModel)]="newPwd">
            </div>
            <div class="full-width fieldTopBottomPadding display-flex">
                <span *ngIf="!newPwdReq" class="hidden-field" style="width: 33%; font-size: 14px; margin-top: -2%;">a</span>
                <span *ngIf="newPwdReq" class="login-error-div">New Password is required</span>
            </div>
        </div>
    </div>
    <div *ngIf="isChangePwd" class="centerWithFlex full-width" style="height: 20%;">
        <div class="full-height" style="width: 90%; display: grid;">
            <div class="full-width vert-center zero-padding">
                <span style="width: 50%; font-size: 14px;">Confirm Password</span>
                <input type="password" id="cnf-pass" name="cnf-pass" [tabIndex]="1" class="form-control" (keyup)="handleCnfPwd($event)" [(ngModel)]="cnfPwd">
            </div>
            <div class="full-width fieldTopBottomPadding display-flex">
                <span *ngIf="!cnfPwdReq" class="hidden-field" style="width: 33%; font-size: 14px; margin-top: -2%;">a</span>
                <span *ngIf="cnfPwdReq" class="login-error-div">Confirm Password is required</span>
            </div>
        </div>
    </div>
    <div *ngIf="isChangePwd" class="topPaddingForComp centerWithFlex full-width " style="height: 20%;">
        <button style="font-size: 14px; min-width: 25%; margin-right: 5%;background-color: green; color: white;" class="btn btn-outline-secondary rounded-pill button-align" (click)="changePwd($event, true)">Continue</button>
        <button style="font-size: medium; min-width: 25%;" class="btn btn-outline-secondary rounded-pill button-align" (click)="closePop($event, false)">Cancel</button>
    </div>

    <div class="topPaddingForComp">

    </div>

</div>